import React from "react";
import Select from "../../../shared/CustomSelect";

export default class ChildhoodJewishInvolvementDemographics extends React.PureComponent {
  render() {
    const {
      demographics: {
        childhoodKosherStatus = "",
        childhoodShabbosHolidayStatus = "",
        childhoodSynagogueAttendanceStatus = "",
        childhoodTefillinStatus = "",
        childhoodTorahStudyStatus = "",
      },
      observanceStatuses,
      onChange,
      participationStatuses,
      pastShabbosHolidayObservanceStatuses,
      studentGender,
    } = this.props;

    return (
      <div className="student-profile-form-section">
        <p className="profile-section-title">Childhood Jewish Involvement</p>
        <div className="student-profile-form-grid">
          <div className="input-container">
            <label>Shabbos and Holiday Status</label>
            <Select
              classNamePrefix="input-container-select"
              name="childhoodShabbosHolidayStatus"
              onChange={onChange}
              options={
                pastShabbosHolidayObservanceStatuses &&
                pastShabbosHolidayObservanceStatuses.map((s) => ({
                  label: s.displayValue,
                  value: s.enumValue,
                }))
              }
              placeholder="Select Status"
              searchable={true}
              value={childhoodShabbosHolidayStatus}
            />
          </div>
          <div className="input-container">
            <label>Kosher Status</label>
            <Select
              classNamePrefix="input-container-select"
              name="childhoodKosherStatus"
              onChange={onChange}
              options={
                observanceStatuses &&
                observanceStatuses.map((s) => ({
                  label: s.displayValue,
                  value: s.enumValue,
                }))
              }
              placeholder="Select Status"
              searchable={true}
              value={childhoodKosherStatus}
            />
          </div>
          <div className="input-container">
            <label>Torah Study Status</label>
            <Select
              classNamePrefix="input-container-select"
              name="childhoodTorahStudyStatus"
              onChange={onChange}
              options={
                participationStatuses &&
                participationStatuses.map((s) => ({
                  label: s.displayValue,
                  value: s.enumValue,
                }))
              }
              placeholder="Select Status"
              searchable={true}
              value={childhoodTorahStudyStatus}
            />
          </div>
          <div className="input-container">
            <label>Synagogue Attendance Status</label>
            <Select
              classNamePrefix="input-container-select"
              name="childhoodSynagogueAttendanceStatus"
              onChange={onChange}
              options={
                participationStatuses &&
                participationStatuses.map((s) => ({
                  label: s.displayValue,
                  value: s.enumValue,
                }))
              }
              placeholder="Select Status"
              searchable={true}
              value={childhoodSynagogueAttendanceStatus}
            />
          </div>
          {studentGender !== "Female" && (
            <div className="input-container">
              <label>Tefillin Status</label>
              <Select
                classNamePrefix="input-container-select"
                name="childhoodTefillinStatus"
                onChange={onChange}
                options={
                  participationStatuses &&
                  participationStatuses.map((s) => ({
                    label: s.displayValue,
                    value: s.enumValue,
                  }))
                }
                placeholder="Select Status"
                searchable={true}
                value={childhoodTefillinStatus}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
